import { z } from 'zod';

/**
 * The 6-digit code Clerk emails when a citizen adds an address to their
 * account — the proof-of-control step that lets them accept an invitation sent
 * to an address other than their primary.
 *
 * Digits only and exactly six, matching what Clerk's `email_code` strategy
 * issues. Validated before the round-trip so a typo is a local error rather
 * than a consumed verification attempt.
 */
export const emailVerificationCodeSchema = z.object({
  code: z
    .string()
    .trim()
    .regex(/^\d{6}$/, 'validation.code.sixDigits'),
});

export type EmailVerificationCodeInput = z.infer<typeof emailVerificationCodeSchema>;
